import React from 'react'
import _ from 'lodash'
import { is, List, Map, Stack } from 'immutable'
import { connect } from 'react-redux'
import { Clipboard, TouchableOpacity } from 'react-native'

import * as util from 'x/utils/util'
import { getStoreSelected, getSelectedProduct } from 'x/redux/selectors'
import * as NavActions from 'x/utils/navigation'
import * as api from 'x/utils/api'
import p from 'x/config/platform-specific'

import {
  IProductDetailItemMap,
  IVariantMkpInfo,
  ISelectedStoreMap,
  IProductDetailVariant,
  IComputedVariantMkpInfo,
  IAnyObject,
  INavHeaderButtonProps,
  IProductAssemblerNavParams,
  IXScreenProps,
  ISearchProductItem,
  IBundleProductMapping,
  IBundleProductVariant,
  IProductBundleQtyMapping,
  IProductDetailBundledVariant,
  IProductDetailAssembledVariant,
  IAssemblyProductVariant,
  IProductVariantWarehouse,
} from 'x/index'

import XText from 'xui/components/XText'
import XCard from 'xui/components/XCard'
import VStack from 'xui/components/VStack'
import HStack from 'xui/components/HStack'
import MkpLogo from 'xui/components/MkpLogo'
import XContainer from 'xui/components/XContainer'
import XContent from 'xui/components/XContent'
import XCustomHeader from 'xui/components/XCustomHeader'
import XImage from 'xui/components/XImage'
import Box from 'xui/components/Box'
import XButton from 'xui/components/XButton'
import XIcon from 'xui/components/XIcon'
import XSellyLogo from 'xui/components/XSellyLogo'
import XInput from 'xui/components/XInput'
import XNumericInput from 'xui/components/XNumericInput'
import HelpButton from 'xui/components/HelpButton'
import XSpinner from 'xui/components/XSpinner'
import ForwardIcon from 'xui/components/ForwardIcon'
import WarehousePicker, { WarehousePickerBase } from 'xui/components/product/WarehousePicker'

interface IProps extends IXScreenProps<IProductAssemblerNavParams> {
  selectedStore: ISelectedStoreMap
}

interface IState {
  isInitialized?: boolean
  isWarehouseSelectorVisible: boolean

  selectedProductVariant: IProductDetailVariant
  selectedAssemblyProductVariant: IAssemblyProductVariant

  selectedProductAssemblyWarehouse?: IProductVariantWarehouse

  productAssembledWarehouses?: {
    [pp_id: number]: IProductVariantWarehouse[]
  }
  selectedProductAssembledWarehouses?: {
    [pp_id: number]: IProductVariantWarehouse
  }

  editingQty: number
}

class ProductAssembler extends React.Component<IProps, IState> {
  static displayName = 'ProductAssembler'

  inProcess?: boolean

  warehousePickerRef: React.RefObject<WarehousePickerBase>

  constructor(props) {
    super(props)
    this.state = {
      isInitialized: false,
      isWarehouseSelectorVisible: false,
      selectedProductVariant: null,
      selectedAssemblyProductVariant: null,
      editingQty: 1,
    }

    this.warehousePickerRef = React.createRef()
  }

  async componentDidMount() {
    await this._initialize()
    await util.delay(100)
    await this._fetchProductAssemblyDetail()
    await util.delay(100)
    await this._fetchAssembledProducts()
    await util.delay(100)
    await util.setStatePromise(this, { isInitialized: true })
  }

  _initialize = async () => {
    const { selectedStore } = this.props
    const warehouses = selectedStore.get('warehouses') || List([])
    let isWarehouseSelectorVisible = false

    if (warehouses.size > 1) {
      isWarehouseSelectorVisible = true
    }

    const selectedProductVariant = util.getNavParam(this.props, 'selectedProductVariant')

    if (!selectedProductVariant || !('product_assembly_id' in selectedProductVariant)) {
      p.op.showToast('ไม่พบข้อมูลสินค้า', 'danger')
      this._goBack()
      return
    }

    const selectedProductAssemblyWarehouse = selectedProductVariant.warehouses[0] || null

    await util.setStatePromise(this, { selectedProductVariant, selectedProductAssemblyWarehouse, isWarehouseSelectorVisible })
  }

  _getMode = () => {
    const mode = util.getNavParam(this.props, 'mode', 'assemble')
    return mode
  }

  _fetchProductAssemblyDetail = async () => {
    const store_id = util.getNavParam(this.props, 'store_id')
    const product_assembly_id = util.getNavParam(this.props, 'product_assembly_id')
    if (!product_assembly_id) {
      return
    }

    try {
      const res = await api.fetchProductAssemblyDetail({ store_id, product_assembly_id })
      await this._loadProductBundleDetail(res)
    } catch (error) {
      p.op.showToast('ไม่พบข้อมูลสินค้าเซต', 'danger')
      this._goBack()
    }
  }

  _fetchAssembledProducts = async () => {
    const { selectedStore } = this.props
    const { selectedAssemblyProductVariant, selectedProductAssemblyWarehouse } = this.state

    const store_id = util.getNavParam(this.props, 'store_id')
    const pp_ids = selectedAssemblyProductVariant.assembly_product_mappings.map((mapping) => mapping.pp_id)
    const filterReqBody = util.translateProductListFilterToRequestBody({})
    // console.log('fetchProducts filterReqBody => ', filterReqBody)

    const whSize = selectedStore.get('warehouses').size
    const limit = pp_ids.length * whSize // Fetch all at once

    const reqBody = {
      store_id,
      offset: 0,
      limit,
      c: 1,
      pp_ids,
      ...filterReqBody,
    }

    if (util.isHelper()) {
      // @ts-ignore
      reqBody.is_helper = true
    }

    try {
      const res = await api.searchInventoryProducts(reqBody)
      console.log('_fetchAssembledProducts res => ', res)

      const assembledProducts: ISearchProductItem[] = res.products || []
      const productAssembledWarehouses: { [pp_id: number]: IProductVariantWarehouse[] } = {}
      for (let i = 0; i < assembledProducts.length; i++) {
        const pd = assembledProducts[i]
        const wh = {
          wh_id: pd.v[0].wh_id,
          qty: pd.v[0].q,
          available_qty: pd.v[0].a,
        }

        if (pd.v[0].i in productAssembledWarehouses) {
          productAssembledWarehouses[pd.v[0].i].push(wh)
        } else {
          productAssembledWarehouses[pd.v[0].i] = [wh]
        }
      }

      const selectedProductAssembledWarehouses: { [pp_id: number]: IProductVariantWarehouse } = {}
      for (let j = 0; j < selectedAssemblyProductVariant.assembly_product_mappings.length; j++) {
        const mapping = selectedAssemblyProductVariant.assembly_product_mappings[j]
        const whs = productAssembledWarehouses[mapping.pp_id] || []

        const hasWhs = whs.length > 0
        const matchedWh =
          hasWhs && selectedProductAssemblyWarehouse?.wh_id ? whs.find((wh) => wh.wh_id === selectedProductAssemblyWarehouse.wh_id) : null

        if (hasWhs && matchedWh) {
          selectedProductAssembledWarehouses[mapping.pp_id] = matchedWh
        } else if (hasWhs) {
          selectedProductAssembledWarehouses[mapping.pp_id] = whs[0]
        } else {
          selectedProductAssembledWarehouses[mapping.pp_id] = null
        }
      }
      console.log('selectedProductAssembledWarehouses => ', selectedProductAssembledWarehouses)

      await util.setStatePromise(this, { assembledProducts, productAssembledWarehouses, selectedProductAssembledWarehouses })
    } catch (err) {
      console.log('_fetchAssembledProducts err => ', err)
    }
  }

  _loadProductBundleDetail = async (pdbv: IProductDetailBundledVariant | IProductDetailAssembledVariant) => {
    if (pdbv && 'pp_id' in pdbv) {
      await util.setStatePromise(this, { selectedAssemblyProductVariant: pdbv })
    }
  }

  _goBack = () => {
    util.navGoBack(this.props)
  }

  _getHeaderTitle = () => {
    const mode = this._getMode()
    let headerTitle

    if (mode === 'assemble') {
      headerTitle = 'ประกอบสินค้า'
    }

    if (mode === 'disassemble') {
      headerTitle = 'แยกส่วนสินค้า'
    }

    return headerTitle
  }

  _onSave = async () => {
    if (this.inProcess) {
      return
    }
    this.inProcess = true

    await this._doSave()

    this.inProcess = false
  }

  _doSave = async () => {
    const { selectedAssemblyProductVariant, selectedProductAssembledWarehouses, selectedProductAssemblyWarehouse, editingQty } = this.state
    const mode = this._getMode()
    const ppId = util.getNavParam(this.props, 'pp_id')
    const onSaveSuccess = util.getNavParam(this.props, 'onSaveSuccess')

    if (!('product_assembly_id' in selectedAssemblyProductVariant)) {
      p.op.showToast('ไม่พบข้อมูลสินค้าประกอบ', 'danger')
      return
    }

    // const warehouse_id = util.getNavParam(this.props, 'warehouse_id')
    const warehouse_id = selectedProductAssemblyWarehouse?.wh_id
    if (!warehouse_id) {
      p.op.showToast('ไม่พบคลังสินค้าที่ระบุ', 'danger')
      return
    }

    const assembly_product_mappings = []
    for (let i = 0; i < selectedAssemblyProductVariant.assembly_product_mappings.length; i++) {
      const mapping = selectedAssemblyProductVariant.assembly_product_mappings[i]
      const selectedWh = selectedProductAssembledWarehouses[mapping.pp_id]
      if (!selectedWh || !selectedWh.wh_id) {
        p.op.showToast(`กรุณาเลือกคลังสินค้าสำหรับ ${mapping.pp_name}`, 'danger')
        return
      }

      assembly_product_mappings.push({
        pp_id: mapping.pp_id,
        wh_id: selectedWh.wh_id,
      })
    }

    if (assembly_product_mappings.length < 1) {
      p.op.showToast('ไม่พบข้อมูลสินค้าประกอบ', 'danger')
      return
    }

    try {
      const apiMethod = mode === 'assemble' ? api.productAssemblyAssemble : api.productAssemblyDisassemble

      const res = await apiMethod({
        store_id: util.getNavParam(this.props, 'store_id'),
        product_product_id: ppId,
        product_assembly_id: selectedAssemblyProductVariant.product_assembly_id,
        wh_id: warehouse_id,
        qty: editingQty,

        assembly_product_mappings,
      })

      if (res && 'product_assembly_id' in res) {
        await this._loadProductBundleDetail(res)

        if (_.isFunction(onSaveSuccess)) {
          onSaveSuccess(res)
        }

        this._goBack()
        return
      }
    } catch (error) {
      p.op.showToast(JSON.stringify(error), 'danger')
    }
  }

  _renderCustomHeader = () => {
    return (
      <XCustomHeader
        title={this._getHeaderTitle()}
        headerLeftProps={{ backIcon: true, onPressItem: this._goBack }}
        // headerRightProps={this._getHeaderRightProps()}
      />
    )
  }

  _renderSubmitButton = () => {
    const { isInitialized } = this.state
    const mode = this._getMode()
    let buttonText = 'ยืนยันประกอบสินค้า'

    if (mode === 'disassemble') {
      buttonText = 'ยืนยันแยกส่วนสินค้า'
    }

    const isDisabled = !isInitialized || !this._isAbleToAssembleOrDisassemble()

    return (
      <VStack w='full' alignItems='center' justifyContent='center' px='4' py='2' space='1'>
        {this._renderWarningWarehouseMismatch()}

        <HStack w='full'>
          <XButton w='full' onPress={this._onSave} isDisabled={isDisabled} disabled={isDisabled}>
            {buttonText}
          </XButton>
        </HStack>
      </VStack>
    )
  }

  // _navToProductDetail = (productId: number) => {
  //   const { navigation } = this.props
  //   const storeId = util.getNavParam(this.props, 'store_id')

  //   navigation.dispatch(
  //     NavActions.navToProductViewMyStore({
  //       store_id: storeId,
  //       product_id: productId,
  //       // onSuccessAddProductCallback: this._setDirty,
  //       // onSuccessDeleteProductCallback: this._setDirty,
  //       // onSuccessEditProductCallback: this._setDirty,
  //     })
  //   )
  // }

  _renderAssemblyProductMappingItem = (pbm: IProductBundleQtyMapping, index: number) => {
    // const isNavToProductDetailDisabled = util.getNavParam(this.props, 'isNavToProductDetailDisabled', false)
    // const { selectedBundledProducts } = this.state
    const mode = this._getMode()
    const { pt_id, pp_id, pp_name, pt_name, tiny_img_url, sku, upc } = pbm
    const { selectedProductAssembledWarehouses, productAssembledWarehouses, isWarehouseSelectorVisible, editingQty } = this.state

    const selectedWh = selectedProductAssembledWarehouses[pp_id]
    const warehouseSize = productAssembledWarehouses[pp_id]?.length || 1
    const whName = util.getWarehouseNameTextByWhId(selectedWh?.wh_id)
    const isDisabledWarehouseButton = warehouseSize < 2

    let newQty = null
    if (selectedWh && mode === 'assemble') {
      newQty = selectedWh.qty - pbm.qty * editingQty
    }
    if (selectedWh && mode === 'disassemble') {
      newQty = selectedWh.qty + pbm.qty * editingQty
    }

    return (
      <XCard w='full' key={`${index}_${pp_id}`}>
        <VStack w='full' p='2' minH='12' alignItems='center' space='1'>
          <HStack w='full'>
            <HStack flex={1} p='2' minH='12' space='1'>
              <HStack
                w='48px'
                h='48px'
                alignItems='center'
                justifyContent='center'
                borderWidth='1'
                borderColor='gray.200'
                borderRadius='lg'
                overflow='hidden'
              >
                <XImage w='48px' h='48px' source={{ uri: tiny_img_url }} />
              </HStack>

              <VStack flex={1} space='1'>
                <XText variant='inactive' numberOfLines={1}>
                  {pt_name}
                </XText>
                <XText numberOfLines={1}>{pp_name}</XText>
                {sku && sku.length > 0 && (
                  <XText variant='inactive' fontSize='xs'>
                    SKU: {sku}
                  </XText>
                )}
                {upc && upc.length > 0 && (
                  <XText variant='inactive' fontSize='xs'>
                    UPC: {upc}
                  </XText>
                )}
              </VStack>
            </HStack>

            <XText color='blue.500' underline onPress={() => this._navToAssembledProductVariantStock(pp_id)}>
              ดูสต๊อก
            </XText>
          </HStack>

          <VStack w='full' space='1'>
            <HStack w='full' alignItems='center' space='1'>
              <HStack w='220px' alignItems='center' space='1'>
                <XText variant='inactive'>จำนวน (ต่อ 1 หน่วยสินค้าประกอบ)</XText>
              </HStack>

              <XText flex={1} textAlign='right'>
                {pbm.qty}
              </XText>
            </HStack>

            {selectedWh && (
              <VStack w='full' alignItems='center' space='1'>
                <HStack w='full' alignItems='center' space='1'>
                  <XText variant='inactive'>{isWarehouseSelectorVisible ? 'คงเหลือในคลัง' : 'คงเหลือ'}</XText>

                  {isWarehouseSelectorVisible && isDisabledWarehouseButton && (
                    <XText flex={1} textAlign='right' pr='1'>
                      {whName}
                    </XText>
                  )}

                  {isWarehouseSelectorVisible && !isDisabledWarehouseButton && (
                    <XButton
                      h='28px'
                      w='150px'
                      variant='outline'
                      rightIcon={<ForwardIcon />}
                      onPress={() => this._handlePickAssembledProductWarehouse(pp_id)}
                    >
                      {whName}
                    </XButton>
                  )}

                  <XText flex={1} textAlign='right'>
                    {selectedWh.qty || 0}
                  </XText>
                </HStack>

                {newQty ? (
                  <HStack w='full' alignItems='center' space='1'>
                    <XText flex={1} variant='inactive'>
                      คลังใหม่
                    </XText>

                    <XText bold textAlign='right'>
                      {newQty}
                    </XText>
                  </HStack>
                ) : null}
              </VStack>
            )}
          </VStack>

          <HStack w='full' alignItems='center' space='1'>
            <XText fontSize='xs' variant='inactive'>{`#${index + 1}`}</XText>
            <XText fontSize='xs' variant='inactive' onPress={() => this._handlePressProductID(pp_id)}>{`ID:${pp_id}`}</XText>
          </HStack>
        </VStack>
      </XCard>
    )
  }

  _handlePressProductID = (id: number) => {
    try {
      Clipboard.setString(id.toString())
      p.op.showToast(`คัดลอก ${id} ไปยังคลิปบอร์ดแล้ว`, 'success')
    } catch (error) {
      console.log('_handlePressProductID error => ', error)
    }
  }

  _getNumOfMappings = () => {
    const { selectedAssemblyProductVariant } = this.state
    return selectedAssemblyProductVariant ? selectedAssemblyProductVariant.assembly_product_mappings.length : 0
  }

  _getSumOfMappingQty = () => {
    const { selectedAssemblyProductVariant } = this.state
    if (!selectedAssemblyProductVariant) {
      return 0
    }

    return selectedAssemblyProductVariant.assembly_product_mappings.reduce((sum, mapping) => sum + mapping.qty, 0)
  }

  _handlePickProductVariantWarehouse = () => {
    const { selectedProductVariant } = this.state
    const warehouses = selectedProductVariant.warehouses || []
    const availableWharehouseIds = warehouses.map((wh) => wh.wh_id)

    this.warehousePickerRef.current?.openPicker({
      onPick: (whId) => {
        const pickedWh = warehouses.find((wh) => wh.wh_id === whId)
        this.setState({ selectedProductAssemblyWarehouse: pickedWh })
      },
      availableWharehouseIds,
    })
  }

  _handlePickAssembledProductWarehouse = (ppId: number) => {
    const { productAssembledWarehouses, selectedProductAssembledWarehouses: oldSPAW } = this.state
    const warehouses = productAssembledWarehouses[ppId] || []
    const availableWharehouseIds = warehouses.map((wh) => wh.wh_id)

    this.warehousePickerRef.current?.openPicker({
      onPick: (whId) => {
        const pickedWh = warehouses.find((wh) => wh.wh_id === whId)
        this.setState({ selectedProductAssembledWarehouses: { ...oldSPAW, [ppId]: pickedWh } })
      },
      availableWharehouseIds,
    })
  }

  _renderSelectedProductVariantWarehouse = () => {
    const { selectedProductVariant, selectedProductAssemblyWarehouse, isWarehouseSelectorVisible } = this.state

    if (!isWarehouseSelectorVisible) {
      return null
    }

    const warehouses = selectedProductVariant.warehouses || []
    // if (warehouses.length < 2) {
    //   return null
    // }

    const whName = util.getWarehouseNameTextByWhId(selectedProductAssemblyWarehouse?.wh_id)
    const isDisabledWarehouseButton = warehouses.length < 2
    return (
      <VStack w='full'>
        <XCard>
          <VStack w='full' p='2' space='2' bg='gray.50'>
            <HStack w='full' alignItems='center' space='1'>
              <HStack flex={1} alignItems='center' space='1'>
                <XText variant='inactive'>สินค้าจากคลัง</XText>
              </HStack>

              {isDisabledWarehouseButton ? (
                <XText flex={1} textAlign='right' pr='1'>
                  {whName}
                </XText>
              ) : (
                <XButton h='28px' w='150px' variant='outline' rightIcon={<ForwardIcon />} onPress={this._handlePickProductVariantWarehouse}>
                  {whName}
                </XButton>
              )}
            </HStack>
          </VStack>
        </XCard>
      </VStack>
    )
  }

  _isAbleToAssembleOrDisassemble = () => {
    const {
      selectedProductVariant,
      selectedProductAssemblyWarehouse,
      selectedProductAssembledWarehouses,
      selectedAssemblyProductVariant,
      editingQty,
    } = this.state
    const mode = this._getMode()

    if (!selectedProductVariant || !selectedProductAssemblyWarehouse) {
      return false
    }

    const currentQty = selectedProductVariant.warehouses.find((wh) => wh.wh_id === selectedProductAssemblyWarehouse?.wh_id)?.qty || 0
    const demandForAssembledProducts = selectedAssemblyProductVariant.assembly_product_mappings.map((mapping) => {
      const selectedWh = selectedProductAssembledWarehouses[mapping.pp_id]
      const availableQty = selectedWh ? selectedWh.qty : 0
      const totalDemandQty = mapping.qty * editingQty
      return availableQty - totalDemandQty
    })

    if (mode === 'assemble') {
      const isAbleToAssembleAll = demandForAssembledProducts.every((val) => val >= 0)
      return isAbleToAssembleAll && editingQty > 0
    }

    if (mode === 'disassemble') {
      const isAbleToDisassemble = currentQty >= editingQty && editingQty > 0
      return isAbleToDisassemble
    }

    return false
  }

  _renderWarningWarehouseMismatch = () => {
    const { isInitialized, selectedProductAssembledWarehouses, selectedProductAssemblyWarehouse } = this.state
    if (!isInitialized) {
      return null
    }

    if (!selectedProductAssemblyWarehouse) {
      return null
    }

    if (!selectedProductAssembledWarehouses || _.isEmpty(selectedProductAssembledWarehouses)) {
      return null
    }

    let allMatched = true
    const paWhId = selectedProductAssemblyWarehouse?.wh_id

    const ppIds = Object.keys(selectedProductAssembledWarehouses)
    for (let i = 0; i < ppIds.length; i++) {
      const ppId = ppIds[i]
      const selectedWh = selectedProductAssembledWarehouses[ppId]
      if (selectedWh?.wh_id !== paWhId) {
        allMatched = false
        break
      }
    }

    if (allMatched) {
      return null
    }

    const opText = this._getMode() === 'assemble' ? 'ประกอบ' : 'แยกส่วน'

    return (
      <HStack w='full' py='2' bg='warning.100' borderRadius='full' alignContent='center' justifyContent='center'>
        <XText fontSize='sm' color='warning.900' textAlign='center'>
          {`กำลัง${opText}สินค้าจาก`}
          <XText bold>{'คลังที่ต่างกัน'}</XText>
          {'\nโปรดตรวจสอบให้แน่ใจว่าคุณต้องการดำเนินการต่อ'}
        </XText>
      </HStack>
    )
  }

  _renderWarningCannotAssembleOrDisassemble = () => {
    if (this._isAbleToAssembleOrDisassemble()) {
      return null
    }

    const { selectedAssemblyProductVariant, selectedProductAssembledWarehouses, editingQty } = this.state
    const mode = this._getMode()

    if (mode === 'assemble') {
      const insufficientProducts = selectedAssemblyProductVariant.assembly_product_mappings.filter((mapping) => {
        const selectedWh = selectedProductAssembledWarehouses[mapping.pp_id]
        const availableQty = selectedWh ? selectedWh.qty : 0
        const totalDemandQty = mapping.qty * editingQty
        return availableQty < totalDemandQty
      })

      let warningText = 'ไม่สามารถประกอบสินค้าได้ เนื่องจากสินค้าต่อไปนี้มีจำนวนคงเหลือไม่เพียงพอ: '
      if (editingQty < 1) {
        warningText = 'ไม่สามารถประกอบสินค้าได้ เนื่องจากจำนวนที่ต้องการประกอบต้องมากกว่า 0'
      }
      // else {
      //   const warningProductTexts = insufficientProducts.map((mapping) => {
      //     const selectedWh = selectedProductAssembledWarehouses[mapping.pp_id]
      //     const availableQty = selectedWh ? selectedWh.qty : 0
      //     const totalDemandQty = mapping.qty * editingQty
      //     return `\n ${mapping.pp_name} (คงเหลือ: ${availableQty}, ต้องการ: ${totalDemandQty})`
      //   })
      //   warningText += warningProductTexts.join(', ')
      // }

      return (
        <Box p='2' bg='warning.100' borderRadius='full'>
          <XText fontSize='sm' color='warning.900'>
            {warningText}
          </XText>
          {editingQty >= 1
            ? insufficientProducts.map((mapping) => {
                const selectedWh = selectedProductAssembledWarehouses[mapping.pp_id]
                const availableQty = selectedWh ? selectedWh.qty : 0
                const totalDemandQty = mapping.qty * editingQty
                return (
                  <XText key={mapping.pp_id} fontSize='sm' color='warning.800'>
                    {mapping.pp_name} (คงเหลือ: {availableQty}, ต้องการ: <XText bold>{totalDemandQty}</XText>)
                  </XText>
                )
              })
            : null}
        </Box>
      )
    }

    if (mode === 'disassemble') {
      return (
        <Box p='2' bg='warning.100' borderRadius='lg'>
          <XText fontSize='sm' color='warning.800'>
            ไม่สามารถแยกส่วนสินค้าได้ เนื่องจากจำนวนที่ต้องการแยกมีมากกว่าจำนวนคงเหลือในคลัง
          </XText>
        </Box>
      )
    }

    return null
  }

  _renderEditingQtyInput = () => {
    const { editingQty, selectedProductVariant, selectedProductAssemblyWarehouse } = this.state
    const currentQty = selectedProductVariant.warehouses.find((wh) => wh.wh_id === selectedProductAssemblyWarehouse?.wh_id)?.qty || 0
    const mode = this._getMode()

    const headerText = `เลือกจำนวนที่ต้องการ${mode === 'assemble' ? 'ประกอบ' : 'แยกส่วน'}สินค้า`
    const toChangeText = mode === 'assemble' ? 'เพิ่ม' : 'ลด'

    let newQty = editingQty
    if (mode === 'assemble') {
      newQty = currentQty + editingQty
    } else {
      newQty = currentQty - editingQty
    }

    return (
      <VStack w='full'>
        <XCard>
          <VStack w='full' p='2' space='2' bg='gray.50'>
            <HStack w='full' alignItems='center' justifyContent='center'>
              <XText fontSize='md' bold textAlign='center'>
                {headerText}
              </XText>
            </HStack>

            <HStack w='full' alignItems='center' space='1'>
              <XText w='150px' variant='inactive'>
                จำนวนคงเหลือเดิม
              </XText>

              <XText flex={1} textAlign='right' pr='1'>
                {currentQty}
              </XText>
            </HStack>

            <HStack w='full' alignItems='center' space='1'>
              <XText w='150px' variant='inactive'>
                {toChangeText}
              </XText>

              <HStack flex={1} alignItems='center' justifyContent='flex-end' space='1'>
                <XIcon
                  name={mode === 'assemble' ? 'plus-circle' : 'minus-circle'}
                  family='FontAwesome'
                  variant={mode === 'assemble' ? 'success' : 'danger'}
                />

                <XInput
                  w='100px'
                  isInteger
                  textAlign='right'
                  keyboardType='numeric'
                  value={editingQty.toString()}
                  onChangeText={(newText) => {
                    let val = parseInt(newText)
                    if (_.isNaN(val)) {
                      val = 0
                    }
                    this.setState({ editingQty: val })
                  }}
                  onBlur={() => {
                    if (!editingQty || editingQty < 1) {
                      this.setState({ editingQty: 1 })
                    }
                  }}
                />
              </HStack>
            </HStack>

            <HStack w='full' alignItems='center' space='1'>
              <XText w='150px' variant='inactive'>
                จำนวนคงเหลือใหม่
              </XText>

              <XText flex={1} bold textAlign='right' pr='1'>
                {newQty}
              </XText>
            </HStack>

            {this._renderWarningCannotAssembleOrDisassemble()}
          </VStack>
        </XCard>
      </VStack>
    )
  }

  _navToAssembledProductStack = () => {
    const { selectedAssemblyProductVariant } = this.state
    const { navigation } = this.props
    const storeId = util.getNavParam(this.props, 'store_id')

    const ppIds = selectedAssemblyProductVariant.assembly_product_mappings.map((mapping) => mapping.pp_id)

    navigation.dispatch(
      NavActions.navToSearchProductVariantListView({
        store_id: storeId,
        pp_ids: ppIds,
        isNavToProductDetailDisabled: true,
        isBundleOperationsDisabled: true,
      })
    )
  }

  _navToAssembledProductVariantStock = (ppId: number) => {
    const { navigation } = this.props
    const storeId = util.getNavParam(this.props, 'store_id')

    navigation.dispatch(
      NavActions.navToSearchProductVariantListView({
        store_id: storeId,
        pp_ids: [ppId],
        isNavToProductDetailDisabled: true,
        isBundleOperationsDisabled: true,
      })
    )
  }

  _renderContent = () => {
    const { selectedAssemblyProductVariant, isInitialized } = this.state

    if (!isInitialized) {
      return (
        <VStack w='full' h='200px' alignItems='center' justifyContent='center'>
          <XSpinner />
        </VStack>
      )
    }

    return (
      <VStack w='full' p='2' space='1'>
        {this._renderSelectedProductVariantWarehouse()}
        {this._renderEditingQtyInput()}

        <HStack w='full' py='1.5' alignItems='center' space='1'>
          <VStack flex={1}>
            <XText variant='inactive'>
              เป็นสินค้าประกอบ ({this._getNumOfMappings()} สินค้า {this._getSumOfMappingQty()} ชิ้น)
            </XText>
          </VStack>

          {/* <XButton
            w='118px'
            h='24px'
            size='xs'
            variant='outline'
            leftIcon={<XIcon name='albums' />}
            onPress={this._navToAssembledProductStack}
          >
            ดูรายการสต๊อก
          </XButton> */}
        </HStack>
        {selectedAssemblyProductVariant.assembly_product_mappings.map(this._renderAssemblyProductMappingItem)}
      </VStack>
    )
  }

  render() {
    // const { isInitialized } = this.state
    // if (!isInitialized) {
    //   return null
    // }

    const renderNavReference = util.getNavParam(this.props, 'renderNavReference')

    return (
      <XContainer>
        {this._renderCustomHeader()}
        {_.isFunction(renderNavReference) ? (
          <HStack w='full' p='2'>
            {renderNavReference()}
          </HStack>
        ) : null}
        {/* {this._renderSearchBar()} */}

        <XContent style={{ backgroundColor: 'white' }}>{this._renderContent()}</XContent>

        {this._renderSubmitButton()}
        <WarehousePicker ref={this.warehousePickerRef} />
      </XContainer>
    )
  }
}

export default connect(
  (state) => ({
    selectedStore: getStoreSelected(state),
    // selectedProduct: getSelectedProduct(state),
    // mkpChannels: getMkpChannels(state),
  }),
  (dispatch) => ({
    dispatch,
  })
)(ProductAssembler)
